import userGWFragments from '@shared/hooks/usegwFragments';
import { secureLocalStorageGet } from '../../helpers/index';
import { http } from '../http'


export const getBranchList = async (): Promise<any[]> => {
    const userFragments = userGWFragments();
  
    const { data } = await http.post<any>(
    `gateway/${userFragments.customerNo}/inquiry`,
    {
      url: '/ib/order/card/salary/bank/branches',
      data: userFragments,
    }
  )

  if (data.data.code !== 200) {
    throw new Error(data.data.message);
  }

  return data.data.data
}